import React, { useEffect } from 'react';
import { Col, Input, Modal } from 'reactstrap';
import { Btn, H4, H5, P } from '../../../../AbstractElements';
import { formatCurrency } from '../../../../Library/custom_utils';

const TransactionModal = ({ hook }) => {
    const { 
        modal, 
        toggleModal, 
        amount, 
        handleAmountChange, 
        executeTransfer, 
        transactionConfig, 
        loading, 
        fetchWalletInfo 
    } = hook;

    // Refresh wallet info when modal opens to ensure balance is current
    useEffect(() => {
        if (modal) fetchWalletInfo();
    }, [modal, fetchWalletInfo]);

    return (
        <Modal isOpen={modal} toggle={() => toggleModal()} centered>
            <div className='p-4 d-flex flex-column' style={{ gap: 20 }}>
                <div className="text-center">
                    <H4 className="text-capitalize" attrH4={{ className: 'fw-bold' }}>
                        Manual Debit / Deduction
                    </H4>
                    <P className="text-muted">Target: {transactionConfig.wallet} Wallet</P>
                    <hr />
                </div>

                <div className="bg-light p-3 rounded text-center">
                    <P className="mb-1 text-muted small">Current Balance</P>
                    <H5 attrH5={{ className: 'fw-bold text-dark mb-0' }}>
                        {formatCurrency(transactionConfig.balance)}
                    </H5>
                </div>

                <Col xs={12} className='p-0'>
                    <P className="mb-2 fw-bold">Amount to Deduct (₦)</P>
                    <Input 
                        className='form-control text-center' 
                        type='text' 
                        placeholder='0.00'
                        value={amount} 
                        onChange={handleAmountChange}
                        style={{ 
                            fontSize: '24px', 
                            fontWeight: '800', 
                            borderRadius: '10px', 
                            height: '60px',
                            border: '2px solid #eee'
                        }}
                    />
                    <P className="mt-2 text-danger small text-center">
                        *This action will immediately reduce the user's balance.
                    </P>
                </Col>

                <div className="d-flex gap-2">
                    <Btn attrBtn={{ 
                        color: 'light', 
                        onClick: () => toggleModal(), 
                        className: 'w-50',
                        style: { borderRadius: '10px', fontWeight: 'bold' } 
                    }}>
                        Cancel
                    </Btn>
                    <Btn attrBtn={{ 
                        color: 'danger', 
                        onClick: executeTransfer, 
                        disabled: loading || !amount || amount === '0.00', 
                        className: 'w-50 shadow-sm',
                        style: { borderRadius: '10px', fontWeight: 'bold' } 
                    }}>
                        {loading ? 'Processing...' : `Confirm Debit`}
                    </Btn>
                </div>
            </div>
        </Modal>
    );
};

export default TransactionModal;